/**
 * @generated SignedSource<<db0f2f25401b90b93b85567c3acd5507>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "auditDetail"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "auditType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rlimit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "severities"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v9 = [
  {
    "kind": "Variable",
    "name": "accountName",
    "variableName": "accountName"
  },
  {
    "kind": "Variable",
    "name": "auditDetail",
    "variableName": "auditDetail"
  },
  {
    "kind": "Variable",
    "name": "auditType",
    "variableName": "auditType"
  },
  {
    "kind": "Variable",
    "name": "endTs",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "rlimit",
    "variableName": "rlimit"
  },
  {
    "kind": "Variable",
    "name": "severities",
    "variableName": "severities"
  },
  {
    "kind": "Variable",
    "name": "startTs",
    "variableName": "startDate"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuditsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "AuditEntriesConnection",
        "kind": "LinkedField",
        "name": "getauditentries2",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuditsList_al"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AuditsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "AuditEntriesConnection",
        "kind": "LinkedField",
        "name": "getauditentries2",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AuditEntry",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "severity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditDetail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7632204ef03908dca3b7adb506a7bcd2",
    "id": null,
    "metadata": {},
    "name": "AuditsQuery",
    "operationKind": "query",
    "text": "query AuditsQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountName: String\n  $severities: [Int]\n  $auditType: String\n  $auditDetail: String\n  $rlimit: Int\n  $first: Int\n  $offset: Int\n) {\n  getauditentries2(startTs: $startDate, endTs: $endDate, accountName: $accountName, severities: $severities, auditType: $auditType, auditDetail: $auditDetail, rlimit: $rlimit, first: $first, offset: $offset) {\n    totalCount\n    ...AuditsList_al\n  }\n}\n\nfragment AuditsList_al on AuditEntriesConnection {\n  nodes {\n    auditId\n    accountId\n    accountName\n    accountType\n    userId\n    severity\n    auditType\n    auditDetail\n    auditTime\n  }\n}\n"
  }
};
})();

node.hash = "d0ad027daa8562850bb43641ebc58a07";

module.exports = node;
